import { DialogData } from '@shure/shared/angular/ui/components/dialogs/common-models';

export interface ConfirmDialogData extends DialogData {
	title?: string;
	body?: Array<string | DialogBody>;
	confirmLabel: string;
	cancelLabel: string;
	showIcon?: ShowIcon;
	doNotShowDialogId?: string;
}

export enum ShowIcon {
	Warning = 'Warning',
	Info = 'Info'
}

export interface ConfirmDialogResult {
	confirmed: boolean;
	doNotShowDialog: boolean;
}

export interface DialogBody {
	text: string;
	icon: string;
}
